import * as React from 'react';
import ActionButton from './ActionButton';

interface Props {
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
  canConfirm: boolean;
}

const ConfirmationBar: React.FunctionComponent<Props> = props => {
  return (
    <div className="confirmation-bar">
      <ActionButton onClick={props.onCancel} icon="cancel" padding="11px 5px">
        Cancel
      </ActionButton>
      <ActionButton
        primary={true}
        onClick={props.onConfirm}
        disabled={!props.canConfirm}
        icon="confirm-primary"
      >
        {props.confirmLabel || 'Done'}
      </ActionButton>
    </div>
  );
};

export { ConfirmationBar };



// WEBPACK FOOTER //
// ./src/controller/components/ConfirmationBar.tsx